export const fbTrack = (eventName, params = {}) => {
  if (window.fbq) {
    window.fbq("track", eventName, params);
  } else {
    console.warn("Meta Pixel not loaded yet.");
  }
};
